(() => {
  const script = document.currentScript;
  const previous = script.dataset.previous;
  const next = script.dataset.next;
  let serial = 0;
  function attach(rail) {
    if (rail.parentElement.classList.contains('aonsk-scroll-controls')) return;
    const wrapper = document.createElement('div');
    wrapper.className = 'aonsk-scroll-controls';
    if (!rail.id) rail.id = `aonsk-scroll-strip-${++serial}`;
    const buttons = [-1, 1].map((direction) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', direction < 0 ? previous : next);
      button.setAttribute('aria-controls', rail.id);
      const icon = document.createElement('span');
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = direction < 0 ? '←' : '→';
      button.append(icon);
      button.addEventListener('click', () => {
        const rtl = getComputedStyle(rail).direction === 'rtl';
        rail.scrollBy({ left: direction * (rtl ? -1 : 1) * Math.max(120, rail.clientWidth * .8), behavior: 'instant' });
      });
      return button;
    });
    rail.before(wrapper);
    wrapper.append(buttons[0], rail, buttons[1]);
    function update() {
      const overflowing = rail.scrollWidth > rail.clientWidth + 2;
      const value = String(overflowing);
      if (wrapper.dataset.overflow !== value) wrapper.dataset.overflow = value;
      const position = Math.abs(rail.scrollLeft);
      buttons[0].disabled = position < 2;
      buttons[1].disabled = position >= rail.scrollWidth - rail.clientWidth - 2;
    }
    rail.addEventListener('scroll', update, { passive: true });
    const observer = new ResizeObserver(update);
    observer.observe(rail);
    observer.observe(wrapper);
    for (const child of rail.children) observer.observe(child);
    update();
  }
  function scan() {
    document.querySelectorAll('.bcm6-dept-nav__inner, .bcm6-recently-home__rail').forEach(attach);
  }
  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();